"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    makeUniqueIdSource: function() {
        return makeUniqueIdSource;
    },
    UniqueIdContext: function() {
        return UniqueIdContext;
    },
    useUniqueId: function() {
        return useUniqueId;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
function makeUniqueIdSource(prefix) {
    return {
        prefix,
        index: 0
    };
}
const UniqueIdContext = _react.default.createContext(makeUniqueIdSource('global'));
function useUniqueId() {
    const idSource = (0, _react.useContext)(UniqueIdContext);
    const value = (0, _react.useMemo)(()=>{
        const id = `${idSource.prefix}-${idSource.index}`;
        // Increment the idSource's index so the next component that uses this will have an index one higher
        idSource.index++;
        return id;
    }, [
        idSource
    ]);
    return value;
}
